export const DEVELOPER = {
  name: "Rafael Sandoval",
  job: "Senior Software Developer",
  image: "/avatar.png",
  type: "website",
  website: "https://sandovalrd.dev",
};

export const FRONTEND = [
  {
    type: "Javascript",
    level: 100,
  },
  {
    type: "Typescript",
    level: 100,
  },
  {
    type: "HTML",
    level: 100,
  },
  {
    type: "ReactJS",
    level: 90,
  },
  {
    type: "Unit tests",
    level: 90,
  },
  {
    type: "CSS",
    level: 75,
  },
  {
    type: "AngularJS",
    level: 60,
  },
];
export const BACKEND = [
  {
    type: "Typescript",
    level: 100,
  },
  {
    type: "NodeJS",
    level: 95,
  },
  {
    type: "Golang",
    level: 90,
  },
  {
    type: "Python",
    level: 90,
  },
  {
    type: "NestJs",
    level: 90,
  },
  {
    type: "Unit tests",
    level: 90,
  },
  {
    type: "PHP",
    level: 70,
  },
];
export const OTHERS = [
  {
    type: "GIT",
    level: 95,
  },
  {
    type: "Linux",
    level: 95,
  },
  {
    type: "Docker",
    level: 90,
  },
  {
    type: "Kubernetes",
    level: 85,
  },
  {
    type: "GCP Google Cloud Platform",
    level: 70,
  },
  {
    type: "Terraform",
    level: 60,
  },
];
export const DB = [
  {
    type: "SQL",
    level: 100,
  },
  {
    type: "Postgres",
    level: 95,
  },
  {
    type: "MySql",
    level: 80,
  },
  {
    type: "Oracle",
    level: 70,
  },
  {
    type: "NoSQL",
    level: 70,
  },
  {
    type: "MongoDb",
    level: 70,
  },
];
export const SOCIALINKS = {
  linkedin: "https://www.linkedin.com/in/rafael-sandoval-0b441179/",
  github: "https://github.com/sandovalrd",
};
export const EXPERIENCE_EN = [
  {
    job: "Full Stack Developer",
    image: "img/falabella.jpeg",
    content:
      "Insourced by Fallabella Technology to give continuity and maintenance to the development of microservices and APIs of the different business areas, mainly using NodeJs or NestJs for this purpose.",
    company: "Fallabela",
    date: "January 2022 - Mayo 2026",
    web: "https://falabella.com/",
  },
  {
    job: "Full Stack Developer",
    image: "img/xintec.png",
    content:
      "Development of microservices for the different areas of Falabella's business, using NodeJs or NestJs. Web development and APIs consultation with ReactJs. Working with agile methodologies.",
    company: "Xintec",
    date: "April 2021 - December 2021",
    web: "https://xintec.cl/",
  },
  {
    job: "Frontend Developer",
    image: "img/imagemaker.png",
    content:
      "Participate in the development of the ScotiaBank insurance portal as the only frontend developer using the ReactJs Javascript library, participate together with the UX/UI in the design of user interfaces using the Figma software. Worked under agile methodologies.",
    company: "Imagemaker",
    date: "June 2020 - April 2021",
    web: "https://www.imagemaker.com/",
  },
  {
    job: "Full Stack Developer",
    image: "img/trebol.jpeg",
    content:
      "Development of microservices for the admission system of the German Clinic, using NodeJs. Participate in the development of the admissions system website using ReactJs. Agile methodologies were used.",
    company: "Trebol IT",
    date: "September 2019 - June 2020",
    web: "https://www.trebol-it.com/",
  },
  {
    job: "Software Developer",
    image: "img/acepta-sovos.jpeg",
    content:
      "Development of microservices in NodeJs and Python to improve the web applications of the digital invoice business. Stored Procedures in the Posgrest Database.",
    company: "Acepta",
    date: "March 2018 - September 2019",
    web: "https://www.acepta.com/",
  },
  {
    job: "Senior Software Developer",
    image: "img/pdvsa.png",
    content:
      "Development of applications related to the extraction and refining of oil using tools such as Python, PHP and NodeJS in the Backend. Leader of projects related to the oil business. Agile methodologies were used.",
    company: "PDVSA",
    date: "March 2004 - December 2017",
    web: "http://www.pdvsa.com/",
  },
  {
    job: "Systems Analyst",
    image: "img/bancaribe.jpeg",
    content:
      "Development of stored procedures in the Sybase database. Analysis and solution of incidents in the current accounts of the Bank's clients.",
    company: "BANCARIBE",
    date: "January 2000 - March 2004",
    web: "https://www.bancaribe.com.ve/",
  },
];
export const EXPERIENCE_ES = [
  {
    job: "Full Stack Developer",
    image: "img/falabella.jpeg",
    content:
      "Lideré la migración de la infraestructura de Documentos Tributarios Electrónicos (DTE) hacia una arquitectura cloud en GCP, transformando servicios legados en NodeJs/NestJs a microservicios de alto rendimiento en Golang. Esta modernización optimizó los tiempos de respuesta y garantizó la escalabilidad en la entrega de facturas electrónicas sobre una arquitectura en Google Cloud Platform (GCP).",
    company: "Fallabela",
    date: "Enero 2022 - May 2026",
    web: "https://falabella.com/",
  },
  {
    job: "Developer Full Stack",
    image: "img/xintec.png",
    content:
      "Desarrollé microservicios para diversas áreas de Falabella utilizando NodeJs y NestJs, además de liderar el desarrollo web y la integración de APIs con ReactJS, ejecuté estas funciones trabajando bajo metodologías ágiles.",
    company: "Xintec",
    date: "April 2021 - December 2021",
    web: "https://xintec.cl/",
  },
  {
    job: "Frontend Developer",
    image: "img/imagemaker.png",
    content:
      "Participé en el desarrollo del portal de seguros del Banco ScotiaBank como único desarrollador frontend en ReactJs. Se trabajo bajo metodologías ágiles.",
    company: "Imagemaker",
    date: "June 2020 - April 2021",
    web: "https://www.imagemaker.com/",
  },
  {
    job: "Full Stack Developer",
    image: "img/trebol.jpeg",
    content:
      "Desarrollé microservicios para el sistema de admisión de la Clínica Alemana, utilizando NodeJs, además de participar en el desarrollo del sitio web de dicho sistema utilizando ReactJs. Se trabajo bajo metodologías ágiles.",
    company: "Trebol IT",
    date: "September 2019 - June 2020",
    web: "https://www.trebol-it.com/",
  },
  {
    job: "Software Developer",
    image: "img/acepta-sovos.jpeg",
    content:
      "Desarrollé microservicios en Python para la unidad de DTE e implementé mejoras técnicas en el sistema ICar para aumentar la confiabilidad de la plataforma. Utilicé PostgreSQL Shell (psql) para la creación de scripts y el ajuste de rendimiento, garantizando la consistencia de los datos y optimizando los tiempos de respuesta en plataformas transaccionales.",
    company: "Acepta",
    date: "March 2018 - September 2019",
    web: "https://www.acepta.com/",
  },
  {
    job: "Senior Software Developer",
    image: "img/pdvsa.png",
    content:
      "Diseñé y desarrollé sistemas distribuidos y aplicaciones backend para la producción y cadena de suministro petrolera usando Python, NodeJs y PHP. Lideré equipos ágiles durante todo el ciclo de vida del software, optimizando bases de datos a gran escala e integrando sistemas legados con arquitecturas modernas. Desarrollé herramientas de automatización que mejoraron significativamente la confiabilidad de los datos y el monitoreo operativo.",
    company: "PDVSA",
    date: "March 2004 - December 2017",
    web: "http://www.pdvsa.com/",
  },
  {
    job: "Analista de Sistemas",
    image: "img/bancaribe.jpeg",
    content:
      "Desarrollé procedimientos almacenados en la base de datos Sybase. Análisis y solución de incidencias en las cuentas corrientes de los clientes del Banco.",
    company: "BANCARIBE",
    date: "January 2000 - March 2004",
    web: "https://www.bancaribe.com.ve/",
  },
];
export const CV = {
  spanish: "doc/Rafael_Sandoval_Full_Stack_Spanish.pdf",
  english: "doc/Rafael_Sandoval_Full_Stack_English.pdf",
};
export const PROJECTS_EN = [
  {
    description:
      "Web portfolio available to show the profile and projects of the developer.",
    technology: "Developed in ReactJs",
    domain: "https://sandovalrd.website/",
    state: "Ready",
    color: "bg-yellow-500",
    type: "Frontend",
    date: "20210901",
    branch: "https://github.com/sandovalrd/porfolio/tree/main",
  },
];
export const PROJECTS_ES = [
  {
    description:
      "Portafolio web disponible para mostrar el perfil y proyectos del desarrollador.",
    technology: "Desarrollado en ReactJs",
    domain: "https://sandovalrd.website/",
    state: "Listo",
    color: "bg-yellow-500",
    type: "Frontend",
    date: "20210901",
    branch: "https://github.com/sandovalrd/porfolio/tree/main",
  },
];
